const createStepTitles = {
  own_security_universe: [
    {
      title: "Select Type",
      full_title: "Select a pre-defined model based on Risk Profiling",
    },
    {
      title: "Tuners",
      full_title: "Configure limits ",
    },
    {
      title: "Securities",
      full_title:
        "View, Add, Remove Securities from Universe to use for portfolio creation",
    },
    // {
    //   title: "Limits",
    //   full_title:
    //     "Configure limits accross Fund Types, Asset Class, Classification & Style",
    // },
    {
      title: "Create",
      full_title: "Configure portfolio name",
    },
  ],
  analyze_an_existing_portfolio: [
    {
      title: "Select Type",
      full_title: "Select a pre-defined model based on Risk Profiling",
    },
    {
      title: "Securities",
      full_title:
        "View, Add, Remove Securities from Universe to use for portfolio creation",
    },
    {
      title: "Analysis",
      full_title: "Analysis of uploaded portfolio",
    },
  ],
  curated_portfolio: [
    {
      title: "Select Type",
      full_title: "Select Type",
    },
    {
      title: "Risk Profile",
      full_title: "Select a pre-defined model based on Risk Profiling",
    },
    {
      title: "Tuners",
      full_title: "Configure limits ",
    },
    {
      title: "Securities",
      full_title:
        "View, Add, Remove Securities from Universe to use for portfolio creation",
    },
    // {
    //   title: "Limits",
    //   full_title:
    //     "Configure limits accross Fund Types, Asset Class, Classification & Style",
    // },
    {
      title: "Create",
      full_title: "Configure portfolio name",
    },
  ],
  create_portfolio_theme_based: [
    {
      title: "Select Theme",
      full_title: "Select a pre-defined model based on Risk Profiling",
    },
    {
      title: "Create",
      full_title:
        "View, Add, Remove Securities from Universe to use for portfolio creation, Configure portfolio name",
    },
  ],
  optimize_universe_myUniverse: [
    {
      title: "Select Type",
      full_title: "Select a pre-defined model based on Risk Profiling",
    },
    {
      title: "Securities",
      full_title:
        "View, Add, Remove Securities from Universe to use for portfolio creation",
    },
    {
      title: "Analysis",
      full_title: "Analysis of uploaded portfolio",
    },
    {
      title: "Tuners",
      full_title: "Configure limits ",
    },
    {
      title: "UNIVERSE",
      full_title:
        "View, Add, Remove Securities from Universe to use for portfolio creation",
    },
    // {
    //   title: "Limits",
    //   full_title:
    //     "Configure limits accross Fund Types, Asset Class, Classification & Style",
    // },
    {
      title: "Create",
      full_title: "Configure portfolio name",
    },
  ],

  step_direct_review: [
    {
      title: "Tuners",
      full_title: "Configure limits ",
    },
    {
      title: "UNIVERSE",
      full_title:
        "View, Add, Remove Securities from Universe to use for portfolio creation",
    },
    // {
    //   title: "Limits",
    //   full_title:
    //     "Configure limits accross Fund Types, Asset Class, Classification & Style",
    // },
    {
      title: "Modify",
      full_title: "Configure portfolio name",
    },
  ],
};

export default createStepTitles;



// WEBPACK FOOTER //
// ./src/components/pages/create.steps.title.js